import { render, staticRenderFns } from "./requisition_create.vue?vue&type=template&id=1c75b3fa&"
import script from "./requisition_create.vue?vue&type=script&lang=js&"
export * from "./requisition_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports